import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../components/global/modal/withModal';
import PhotoSearchUpsell from './PhotoSearchUpsell';

export const PHOTO_SEARCH_UPSELL_MODAL = 'modal/PHOTO_SEARCH_UPSELL';

const propTypes = {
  onRequestClose: PropTypes.func,
  actionProps: PropTypes.shape({
    nextUrl: PropTypes.string,
  }),
};

const PhotoSearchUpsellModal = ({
  onRequestClose,
  actionProps: { nextUrl, dismissible = true } = {},
  ...props
}) => {
  return (
    <Fragment>
      {dismissible && (
        <div className="d-flex align-items-end">
          <button
            aria-label="Dismiss Modal"
            onClick={onRequestClose}
            className="btn-dismiss btn-modal-dismiss"
          />
        </div>
      )}
      <PhotoSearchUpsell
        onClose={onRequestClose}
        nextUrl={nextUrl}
        dismissible={dismissible}
        {...props}
      />
    </Fragment>
  );
};

PhotoSearchUpsellModal.propTypes = propTypes;

export default withModal(PhotoSearchUpsellModal, {
  name: PHOTO_SEARCH_UPSELL_MODAL,
  className: 'photo-search-upsell-modal',
  overlayClassName: 'photo-search-upsell-modal-overlay',
  size: 'md',
  type: 'full',
  hideHeader: true,
  dismissible: false,
});
